import { GET_STUDENT_CREDITS } from 'graphql/credits';
import { useQuery } from 'react-apollo';

export const IsMeetingEnabled = (studentId) => {
  const { data: creditsResp } = useQuery(GET_STUDENT_CREDITS, {
    variables: { userId: studentId },
  });

  const usage = creditsResp?.usage;

  const cc_total = usage?.find((i) => i.credit_type === 'cc')?.available || 0;
  const cc_done = Math.abs(
    usage?.find((i) => i.credit_type === 'cc')?.debit || 0,
  );
  const hc_total = usage?.find((i) => i.credit_type === 'hc')?.available || 0;
  const hc_done = Math.abs(
    usage?.find((i) => i.credit_type === 'hc')?.debit || 0,
  );
  const fa_total = usage?.find((i) => i.credit_type === 'fa')?.available || 0;
  const fa_done = Math.abs(
    usage?.find((i) => i.credit_type === 'fa')?.debit || 0,
  );
  const cc_available = cc_total - cc_done;
  const hc_available = hc_total - hc_done;
  const fa_available = fa_total - fa_done;
  return cc_available > 0 || hc_available > 0 || fa_available > 0;
};
